import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SuiToasterComponent } from '@stride-ui/components';

@Component({
  imports: [SuiToasterComponent, RouterOutlet],
  selector: 'pf-root',
  template: `
    <sui-toaster></sui-toaster>
    <router-outlet></router-outlet>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
